<div class="social">
    <div class="tool">
        <div class="time" >
            <span *ngIf="submitAt!== '' ">{{submitAt}}</span>
        </div>
        <div class="tools">
            <div class="comment" (click)="goComment()">
                <div class="comment_icon" [ngClass]="commentCount? 'active':'' " ></div>
                <span *ngIf="!commentCount">评论</span>
                <span *ngIf="commentCount"  >{{commentCount}}</span>
            </div>
            <div class="favour" (click)="favour()" >
                <div class="favour_icon favour_icon-{{relationId}}" [ngClass] = "userClick? 'active' : '' "  ></div>
                <span class="appreciated appreciated-{{relationId}}"  *ngIf="appreciateCount > 0" [ngClass] = "userClick || showCount? 'active' : '' "  >{{appreciateCount}}</span>
                <span class="appreciate appreciate-{{relationId}}" *ngIf="appreciateCount == 0" >点赞</span>
            </div>
        </div>
    </div>
    <div class="comment" *ngIf="commentList && commentList.length " >
        <div class="line" [ngClass]="{ 'active' : tabNum == 1  }"></div>
        <p *ngIf="tabNum == 0">评论</p>
        <div class="single_comment single_comment-{{relationId}}-{{i}}" *ngFor="let item of commentList;let i = index">
            <div class="infos">
                <div class="info">
                    <img *ngIf="!item.studentCommentHeadimg" src="../../../assets/picture/camp/headPortrait.png" alt="">
                    <img *ngIf="item.studentCommentHeadimg" src="{{item.studentCommentHeadimg}}" alt="">
                    <span>{{item.studentCommentByName}}</span>
                </div>
                <span>{{item.studentCommentAt}}</span>
            </div>
            <div class="content">
                <pre class="con">{{item.studentComment}}</pre>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-social/social.html